import React from "react";

import { ViewList, ViewModule } from "@mui/icons-material";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

export type ViewMode = "cards" | "list";

interface ViewToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (
    event: React.MouseEvent<HTMLElement>,
    newViewMode: ViewMode
  ) => void;
  size?: "small" | "medium" | "large";
  sx?: object;
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  viewMode,
  onViewModeChange,
  size = "small",
  sx = {},
}) => {
  return (
    <ToggleButtonGroup
      value={viewMode}
      exclusive
      onChange={onViewModeChange}
      size={size}
      sx={{ ml: 1, ...sx }}
    >
      <ToggleButton value="cards" aria-label="card view">
        <ViewModule />
      </ToggleButton>
      <ToggleButton value="list" aria-label="list view">
        <ViewList />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewToggle;
